/* eslint-disable require-jsdoc */
export class ExistingSolutions {
    constructor() {
        this.marketUsing = "";
        this.existingExperience = "";
        this.existingLikes = "";
        this.existingDislikes = "";
        this.horrorStories = "";
        this.existingSolutionsWork = "";
    }
}
